"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.settlements = void 0;
exports.settlements = function (axios) {
    return {
        getSettlements: function (request) {
            return axios.get('/settlements', request);
        },
        getSettlementsDownload: function (request) {
            return axios.get('/settlements/download', request);
        },
        getSettlementsExcel: function (request) {
            request.responseType = 'blob';
            axios.defaults.timeout = 30 * 60 * 1000;
            return axios
                .get('/settlements/excel', request)
                .then(function (res) {
                return res;
            })
                .finally(function () {
                axios.defaults.timeout = 30 * 1000;
            });
        },
        getSettlementsMonthly: function (request) {
            return axios.get('/settlements/monthly', request);
        },
        getSettlementsMonthlyTotalAmt: function () {
            return axios.get('/settlements/monthly/total-amt');
        },
        getSettlementsPartnersDownload: function (request) {
            return axios.get('/settlements/partners/download', request);
        },
        getSettlementsPartnersExcel: function (request) {
            request.responseType = 'blob';
            axios.defaults.timeout = 30 * 60 * 1000;
            return axios
                .get('/settlements/partners/excel', request)
                .then(function (res) {
                return res;
            })
                .finally(function () {
                axios.defaults.timeout = 30 * 1000;
            });
        },
        putSettlementsconfigurations: function (request) {
            return axios.put("/settlements/configurations/" + request.params.mallNo, request.data);
        },
        patchSettlementsConfigurations: function (request) {
            return axios.patch("/settlements/configurations/" + request.params.mallNo, request.data);
        },
        getSettlementsconfigurations: function (request) {
            return axios.get("/settlements/configurations/" + request.params.mallNo);
        },
        getSettlementsConfigurationsV2: function (request) {
            return axios.get("/settlements/configurations/" + request.params.mallNo);
        },
        postSettlementsconfigurations: function (request) {
            return axios.post("/settlements/configurations/" + request.params.mallNo, request.data);
        }
    };
};
